﻿import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import classNames from 'classnames';
import { AnchorButton, Intent, Icon as BlueprintIcon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import './Buttons.css';

export function LinkButton(
    {
        id = null,
        intent = "",
        loading = false,
        disabled = false,
        icon = null,
        iconOnly = false,
        text = "",
        openInNewTab = false,
        externalLink = false,
        large = true,
        minimal = false,
        className = "",
        faColour = null,
        state = null,
        href,
        onClick
    }
) {

    let intentValue = "secondary";
    if (intent) {
        switch (intent.toLowerCase()) {
            case "save":
            case "info":
            case "primary":
                intentValue = Intent.PRIMARY;
                break;
            case "warning":
                intentValue = Intent.WARNING;
                break;
            case "danger":
            case "delete":
                intentValue = Intent.DANGER;
                break;
            case "none":
            case "secondary":
                break;
            default:
                intentValue = Intent.NONE;
        }
    }

    // Minimal buttons with no intent, such as listing icon links, keep their plain style.
    if (minimal && (!intent || intent.toLowerCase() === "none")) {
        intentValue = Intent.NONE;
    }

    var navigate = useNavigate();

    function onButtonClick(e) {

        if (externalLink && openInNewTab) {
            return;
        }

        if (externalLink) {
            window.location = href;
        }
        else if (!openInNewTab) {
            e.preventDefault();
            navigate(href, { state: state });
        }

        if (onClick) {
            onClick();
        }
    }

    let iconElement = null;

    if (icon) {
        if (icon.startsWith("fa-")) {
            iconElement = (
                <span
                    className={classNames('fa', icon)}
                    style={{ color: faColour || 'inherit' }}
                />
            );
        } else if (IconNames[icon.toUpperCase()]) {
            iconElement = <BlueprintIcon icon={IconNames[icon.toUpperCase()]} style={{ color: faColour }} />;
        }
    }

    let size;
    if (large) {
        size = "large";
    }

    let variant;
    if (minimal) {
        variant = "minimal";
    }

    return (
        <AnchorButton
            className={classNames('btn-form', { "bp6-skeleton": loading }, className)}
            onClick={onButtonClick}
            icon={iconElement}
            disabled={disabled}
            size={size}
            intent={intentValue}
            href={href}
            target={openInNewTab ? "_blank" : "_self"}
            id={id}
            variant={variant}
        >
            {!iconOnly && text}
        </AnchorButton>
    );
}

LinkButton.propTypes = {
    id: PropTypes.string,
    intent: PropTypes.string,
    loading: PropTypes.bool,
    href: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconOnly: PropTypes.bool,
    text: PropTypes.string,
    openInNewTab: PropTypes.bool,
    onClick: PropTypes.func,
    externalLink: PropTypes.bool,
    large: PropTypes.bool,
    minimal: PropTypes.bool,
    className: PropTypes.string,
    faColour: PropTypes.string,
    state: PropTypes.object,
};